/** Ключи дизайн-токенов → CSS variables */
export const DESIGN_TOKEN_KEYS = [
  'background',
  'foreground',
  'card',
  'primary',
  'primary-foreground',
  'secondary',
  'secondary-foreground',
  'accent',
  'muted',
  'muted-foreground',
  'border',
  'radius',
  'font-heading',
  'font-body',
  'content-max-width',
  'section-spacing',
  'animation-intensity',
  'hero-media-url',
  'logo-url',
  'favicon-url',
  'og-image-url',
  'portfolio-default-mode',
] as const;

export type DesignTokenKey = (typeof DESIGN_TOKEN_KEYS)[number];

export const DEFAULT_DESIGN: Record<string, string> = {
  background: '#0a0a0b',
  foreground: '#f5f5f5',
  card: '#131316',
  primary: '#8b5cf6',
  'primary-foreground': '#fafafa',
  secondary: '#1c1c22',
  'secondary-foreground': '#f5f5f5',
  accent: '#f97316',
  muted: '#131316',
  'muted-foreground': '#8c8c93',
  border: '#2a2a32',
  radius: '0.75rem',
  'font-heading': "'Inter', system-ui, sans-serif",
  'font-body': "'Inter', system-ui, sans-serif",
  'content-max-width': '72rem',
  'section-spacing': '4rem',
  'animation-intensity': '1',
  'portfolio-default-mode': 'grid',
};

export function normalizeDesignPayload(raw: Record<string, unknown>): Record<string, string> {
  const out: Record<string, string> = { ...DEFAULT_DESIGN };
  for (const [key, val] of Object.entries(raw)) {
    if (val === null || val === undefined) continue;
    if (typeof val === 'string' || typeof val === 'number') {
      out[key] = String(val);
    } else if (typeof val === 'object' && 'value' in (val as object)) {
      out[key] = String((val as { value: unknown }).value);
    }
  }
  return out;
}

export function applyDesignToDocument(settings: Record<string, string>) {
  const root = document.documentElement;
  const merged = { ...DEFAULT_DESIGN, ...settings };
  for (const [key, value] of Object.entries(merged)) {
    const cssVar = key.startsWith('--') ? key : `--${key}`;
    root.style.setProperty(cssVar, value);
  }
}
